import {
    Directive,
    HostListener,
    Input,
    Output,
    EventEmitter
  } from '@angular/core';
  import * as dateFns from 'date-fns';
  import ICAL from 'ical.js';
export class CalendarImportDirective {

    
    newImportedEvents: EventEmitter<{ events: any[], calendarName: string }> = new EventEmitter<{
      events: any[];
      calendarName: string
    }>();
/**
 * @param {?} event
 * @return {?}
 */
import (event: any) {
        const /** @type {?} */ reader = new FileReader();
        if (event.target.files && event.target.files.length > 0) {
          const /** @type {?} */ file = event.target.files[0];
          reader.readAsText(file);
          reader.onload = () => {
            const /** @type {?} */ jcalData = ICAL.parse(reader.result);
            const /** @type {?} */ comp = new ICAL.Component(jcalData);
            let /** @type {?} */ res = 'No Name';
            if (comp.getFirstProperty('x-wr-calname')) {
              res = comp.getFirstProperty('x-wr-calname').getFirstValue();
            }
            const /** @type {?} */ vevents = comp.getAllSubcomponents('vevent');
            const /** @type {?} */ data = vevents.map(vevent => {
              const /** @type {?} */ cevent = new ICAL.Event(vevent);
              return {
                title: cevent.summary,
                start: dateFns.parse(cevent.startDate),
                end: dateFns.parse(cevent.endDate),
                description: cevent.description,
                location: cevent.location
              };
            });
            this.newImportedEvents.emit({events: data, calendarName: res});
          };
        }
      }
/**
 * @hidden
 * @param {?} event
 * @return {?}
 */
onChange(event): void {
      this.import(event);
    }
  static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: '[appCalendarImport]'
  }, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'newImportedEvents': [{ type: Output },],
'onChange': [{ type: HostListener, args: ['change', ['$event'], ] },],
};
}

function CalendarImportDirective_tsickle_Closure_declarations() {
/** @type {?} */
CalendarImportDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CalendarImportDirective.ctorParameters;
/** @type {?} */
CalendarImportDirective.propDecorators;
/** @type {?} */
CalendarImportDirective.prototype.newImportedEvents;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
